"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShowPaymentModal = void 0;
const react_1 = require("react");
const BalanceProvider_1 = require("astra-core/containers/BalanceProvider");
const react_router_dom_1 = require("react-router-dom");
const enumIncludes_1 = require("astra-core/utils/enumIncludes");
const hooks_1 = require("../../../store/hooks");
const useGetSearchQuery_1 = require("../../../shared/hooks/useGetSearchQuery");
const usePrevious_1 = require("../../../shared/hooks/usePrevious");
const useTogglePaymentModal_1 = require("./useTogglePaymentModal");
const useShowPaymentModal = () => {
    const togglePaymentModal = (0, useTogglePaymentModal_1.useTogglePaymentModal)();
    const query = (0, useGetSearchQuery_1.useGetSearchQuery)();
    const payment = query.get(BalanceProvider_1.PAYMENT_QUERY_PARAM);
    const paymentModalType = (0, hooks_1.useAppSelector)(BalanceProvider_1.selectPaymentModalType);
    const prevPaymentModalType = (0, usePrevious_1.usePrevious)(paymentModalType);
    const history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(() => {
        if (paymentModalType == null && prevPaymentModalType !== undefined) {
            history.replace({
                search: '',
            });
        }
    }, [history, paymentModalType, prevPaymentModalType]);
    (0, react_1.useEffect)(() => {
        if ((0, enumIncludes_1.enumIncludes)(BalanceProvider_1.EPaymentModalTypes, payment)) {
            togglePaymentModal(payment);
        }
        else {
            togglePaymentModal(null);
        }
    }, [payment, togglePaymentModal]);
};
exports.useShowPaymentModal = useShowPaymentModal;
//# sourceMappingURL=useShowPaymentModal.js.map